<template>
  <div class="order-detail">
    <div class="container">
      <div class="title">发货</div>
      <el-form label-width="110px">
        <div class="info-box">
          <el-row>
            <el-col :span="12" style="font-weight: 500">
              <el-form-item label="订单编号：">{{orderBaseInfo.orderNo}}</el-form-item>
            </el-col>
            <el-col :span="12" class="little-title">
              <el-form-item label="发货单名称：">
                <template slot="label"><span class="red">*</span>发货单名称：</template>
                <el-input
                        v-model="shipInfo.orderShipmentName"
                        placeholder="请输入发货单名称"
                        @focus="wordShow"
                        @blur="wordShow"
                        style="width: 180px;">
                  <i slot="suffix" class="el-icon-edit" style="cursor: pointer;color: #1492FF;"/>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="买方企业名称：">{{orderBaseInfo.purchaseCompany}}</el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="期望到货日期：">{{orderBaseInfo.arriveTimeTxt}}</el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="收货人：">{{shipmentInfo.receiveName}}</el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系电话：">{{shipmentInfo.mobiletelephone}}</el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="电子邮箱：">{{shipmentInfo.email}}</el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="收货地址：">{{shipmentInfo.receiveAddress}}</el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </div>
    <div class="container">
      <div class="title">发货清单</div>
      <TableList
        style="margin-top: 16px"
        :loading="loading"
        :table-data="tableData"
        :table-label="tableLabel"
      >
        <template v-slot:productName="slot">
          <e-tooltip :content="slot.scope.row.productName" :set-length="26" />
        </template>
        <template v-slot:productSkuCode="slot">
          <e-tooltip
            :content="slot.scope.row.productSkuCode"
            :set-length="26"
          />
        </template>
        <!--发货数量-->
        <template v-slot:deliveryQuantity="slot">
          <el-input
            v-model.trim="slot.scope.row.deliveryQuantity"
            type="number"
            oninput="clearNoNum(this)"
            @blur="calDeliveryQuantity(slot.scope.row, slot.scope.$index)"
            class="delivery-quantity"
          ></el-input>
        </template>
        <template #unitweight>
          <div>
            <span style="margin-right: 4px">开通服务项数</span>
          </div>
        </template>
        <!-- 总重量-->
        <template v-slot:unitweight="slot">
          <el-input
            v-model.trim="slot.scope.row.goodsWeight"
            type="number"
            class="delivery-quantity"
            @change="changeNum"
          ></el-input>
        </template>
        <!-- 总体积-->
        <template v-slot:unitvolume="slot">
          <el-input
            v-model.trim="slot.scope.row.goodsVolume"
            type="number"
            @change="changeNum"
            class="delivery-quantity"
          ></el-input>
        </template>
      </TableList>
    </div>
    <div class="container max-width">
      <div class="title line margin-b20">
        配送信息
      </div>
      <div class="tip margin-b20">
        <div>
          <img src="../../../../assets/img/orderDetail/circle.png" alt="" />
        </div>
        <div>
          <p>温馨提示：</p>
          <p>1. 易派客平台仅作为物流相关信息的展示方，提供物流数据展示服务。</p>
          <p>
            2.具体运输商资质、物流合同洽谈与签署、物流报价、物流时效、违约等有关物流实际运作相关的信息与事项，请您与您的合作运输商沟通确认。
          </p>
        </div>
      </div>

      <div class="flex-sc" style="margin-left: 28px">
        配送方式：
        <div class="radio" style="margin-left: 12px">
          <el-radio v-model="shipInfo.transportType" :label="2">第三方物流</el-radio>
          <el-radio v-model="shipInfo.transportType" :label="0">自行配送</el-radio>
          <el-radio v-model="shipInfo.transportType" :label="4">询比价</el-radio>
        </div>
      </div>

      <div class="condition distribution">
        <el-form :inline="true" v-show="Number(shipInfo.transportType) === 0" label-width="110px" >
          <!--自配优化-->
          <el-row>
            <el-col :span="24">
              <el-form-item label="易物流："  class="margin-b20 flex-sc">
                <el-checkbox
                        v-model="transportCapability"
                        style="margin-right: 20px"
                        @change="transportCapabilityChange"
                >使用易物流备案运力（可获取轨迹）</el-checkbox>

                  <eui-btn type="text" @click="toEwuliiu">维护易物流运力</eui-btn>

              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="送货人：">
                <template slot="label"><span class="red-c">*</span>送货人：</template>
                <!--因为姓名可能多个，所以电话唯一，此处取电话-->
                <el-select
                        v-model="deliveryInfo.deliPhone"
                        placeholder="请选择送货人"
                        v-if="transportCapability"
                        @change="driverChange"
                >
                  <el-option
                          v-for="item in driverList"
                          :key="item.phone"
                          :label="item.driver"
                          :value="item.phone"
                  >
                  </el-option>
                </el-select>
                <el-autocomplete
                        class="inline-input"
                        v-else
                        v-model="deliveryInfo.deliName"
                        :fetch-suggestions="querySearch"
                        placeholder="请输入送货人"
                        @select="handleSelect"
                ></el-autocomplete>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系电话：" prop="name">
                <template slot="label"><span class="red-c">*</span>联系电话：</template>
                <el-input
                        :disabled="transportCapability"
                        v-model="deliveryInfo.deliPhone"
                        placeholder="请输入联系电话"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="车牌号：">
                <template slot="label"><span class="red-c">*</span>车牌号：</template>
                <el-select
                        v-model="deliveryInfo.licensePlateNumber"
                        placeholder="请选择车牌号"
                        v-if="transportCapability"
                >
                  <el-option
                          v-for="item in carList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                  >
                  </el-option>
                </el-select>
                <el-input
                        v-else
                        v-model="deliveryInfo.licensePlateNumber"
                        placeholder="请输入车牌号"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="transportCapability">
              <el-form-item label="运输方式：">
                <template slot="label"><span class="red-c">*</span>运输方式：</template>
                <el-select
                        v-model="shipInfo.shippingMethodId"
                        placeholder="请选择运输方式"
                        disabled
                >
                  <el-option
                          v-for="item in eWuliuOption"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="transportCapability" >
            <el-col :span="12">
              <el-form-item label="预计发货时间：">
                <el-date-picker
                        v-model="shipInfo.estimatedShipDate"
                        type="date"
                        :picker-options="pickerOptions"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        placeholder="选择发货时间"
                        @change="estimatedShipDateChange"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="预计到货时间：">
                <el-date-picker
                        v-model="shipInfo.estimatedArrivalTime"
                        :picker-options="pickerOptionsArrivalTime"
                        type="date"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        placeholder="选择发到货时间"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-form
          :inline="true"
          :model="deliveryForm"
          v-show="Number(shipInfo.transportType) === 2"
          label-width="110px"
        >
          <div class="two-col">
            <el-row>
              <el-col :span="12">
                <el-form-item label="运输方式：">
                  <template slot="label"><span class="red-c">*</span>运输方式：</template>
                  <el-select v-model="deliveryMethod" placeholder="请选择运输类型">
                    <el-option
                            v-for="item in transportMethod"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- 运输方式为陆运 才支持 紧急配送 -->
              <el-col :span="12" v-if="deliveryMethod === '2' && deliveryMethod">
                <div class="flex-sc">
                  <el-checkbox v-model="emergencyProcurement"
                  >紧急
                  </el-checkbox
                  >
                  <div v-if="emergencyProcurement" class="flex-sc">
                    <div class="margin-l20 margin-r20">
                      紧急采购可以关联三个工作日内的物流单
                    </div>
                    <eui-btn type="primary" @click="relateLogisticsOrder"
                      >关联物流单</eui-btn
                    >
                  </div>
                </div>
              </el-col>

              <!-- 仅在第三方物流 并且 不是 快递/快运 、陆运 显示 -->
              <div
                v-if="
                  Number(shipInfo.transportType) === 2 &&
                  deliveryMethod !== '2' &&
                  deliveryMethod != '1'
                "
              >
                <el-col :span="12">
                  <el-form-item label="运输商选择：">
                    <template slot="label"><span class="red-c">*</span>运输商选择：</template>
                    <el-select
                            v-model="deliveryForm.carrierId"
                            placeholder="请选择快递公司"
                    >
                      <el-option
                              v-for="item in expressCompary"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="包装类型：" prop="orderType">
                    <el-input
                      v-model="shipInfo.packingType"
                      placeholder="请输入包装类型"
                      :disabled="emergencyProcurement"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </div>

              <el-col :span="12" v-if="deliveryMethod == '1'">
                <el-form-item label="快递单号：">
                  <template slot="label"><span class="red-c">*</span>快递单号：</template>
                  <el-input
                          v-model="shipInfo.billNo"
                          placeholder="请输入快递单号"
                          @blur="supplyChoose"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="deliveryMethod == '1'">
                <el-form-item label="快递公司：">
                  <template slot="label"><span class="red-c">*</span>快递公司：</template>
                  <el-select
                          v-model="deliveryForm.carrierId"
                          placeholder="请选择快递公司">
                    <el-option
                            v-for="item in expressCompary"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <!-- 仅在第三方物流 并且 陆运 显示 -->
              <div v-if="Number(shipInfo.transportType) === 2 && deliveryMethod === '2'">
                <el-col :span="12" v-if="deliveryMethod != '1' && deliveryMethod">
                  <el-form-item label="运输商选择：">
                    <template slot="label"><span class="red-c">*</span>运输商选择：</template>
                    <el-select
                            v-model="deliveryForm.carrierId"
                            placeholder="请选择快递公司"
                            :disabled="emergencyProcurement">
                      <el-option
                              v-for="item in expressCompary"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12" v-if="deliveryMethod != '1'" >
                  <el-form-item label="包装类型：" prop="orderType">
                    <el-input
                      v-model="shipInfo.packingType"
                      placeholder="请输入包装类型"
                      :disabled="emergencyProcurement"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12" v-if="deliveryMethod != '1' && shipInfo.ywlOrderCode">
                  <el-form-item label="易物流单号：" prop="orderType">
                    {{ shipInfo.ywlOrderCode }}
                  </el-form-item>
                </el-col>
              </div>
            </el-row>
            <el-row v-if="deliveryForm.carrierId == 'SF'">
              <el-col>
                <el-form-item label="收件人/寄件人手机号后四位：">
                  <template slot="label"><span class="red-c">*</span>收件人/寄件人手机号后四位：</template>
                  <el-input
                          v-model="shipInfo.phoneAfterf"
                          placeholder="请输入收件人/寄件人手机号后四位"
                          type="number"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form>
        <el-form
          :inline="true"
          :model="deliveryForm"
          v-show="
            Number(shipInfo.transportType) === 2 &&
            deliveryForm.deliveryMethod &&
            deliveryForm.deliveryMethod != '1'"
          label-width="110px"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="发货人：">
                <template slot="label"><span class="red-c">*</span>发货人：</template>
                <el-input
                        v-model="deliveryInfo.deliName"
                        placeholder="请输入发货人"
                        :disabled="emergencyProcurement"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系电话：">
                <template slot="label"><span class="red-c">*</span>联系电话：</template>
                <el-input
                        v-model="deliveryInfo.deliPhone"
                        placeholder="请输入联系电话"
                        :disabled="emergencyProcurement"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <!--这里联级-->
            <el-col :span="24">
              <el-form-item label="发货地：" class="shipping-Address-box">
                <template slot="label"><span class="red-c">*</span>发货地：</template>
                <el-select
                        v-model="provinceData"
                        placeholder="请选择"
                        :disabled="emergencyProcurement"
                        style="margin-right: 10px"
                >
                  <el-option
                          v-for="item in province"
                          :key="item.areaId"
                          :label="item.areaName"
                          :value="item.areaId"
                  ></el-option>
                </el-select>
                <el-select
                        v-model="cityData"
                        placeholder="请选择"
                        :disabled="emergencyProcurement"
                        style="margin-right: 10px"
                >
                  <el-option
                          v-for="item in city"
                          :key="item.areaId"
                          :label="item.areaName"
                          :value="item.areaId"
                  ></el-option>
                </el-select>
                <el-select
                        v-model="countyData"
                        placeholder="请选择"
                        :disabled="emergencyProcurement"
                        style="margin-right: 10px"
                >
                  <el-option
                          v-for="item in county"
                          :key="item.areaId"
                          :label="item.areaName"
                          :value="item.areaId"
                  ></el-option>
                </el-select>
                <el-input
                        v-model="shipInfo.address"
                        placeholder="请输入详细地址"
                        style="margin-right: 10px"
                        :disabled="emergencyProcurement"
                ></el-input>
                <eui-btn
                        type="primary"
                        font-size="12px"
                        @click="chooseShippingAddress"
                        :disabled="emergencyProcurement"
                >选择发货地址</eui-btn
                >
                <eui-btn
                        type="primary"
                        font-size="12px"
                        @click="toAddAddress"
                        :disabled="emergencyProcurement"
                >维护发货地</eui-btn
                >
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="总重量(KG)：">
                <template slot="label"><span class="red-c">*</span>总重量(KG)：</template>
                  <el-input
                          v-model="shipInfo.unitweight"
                          placeholder="请输入总重量"
                          type="Number"
                          :disabled="emergencyProcurement"
                  ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="总体积(m³)：">
                <template slot="label"><span class="red-c">*</span>总体积(m³)：</template>
                <el-input
                        v-model="shipInfo.unitvolume"
                        placeholder="请输入总体积"
                        type="Number"
                        :disabled="emergencyProcurement"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
              <el-col :span="12">
                 <el-form-item label="货物类型：">
                      <el-input
                           v-model="shipInfo.cargoType"
                           placeholder="请输入货物类型"
                           :disabled="emergencyProcurement"
                        ></el-input>
                 </el-form-item>
              </el-col>
          </el-row>
        </el-form>

        <el-form
          :inline="true"
          :model="deliveryForm"
          v-show="Number(shipInfo.transportType) === 4"
          label-width="110px"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="发货人：" prop="name">
                <template slot="label"><span class="red-c">*</span>发货人：</template>
                <el-input
                        v-model="deliveryInfo.deliName"
                        placeholder="请输入发货人"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系电话：" prop="name">
                <template slot="label"><span class="red-c">*</span>联系电话：</template>
                <el-input
                        v-model="deliveryInfo.deliPhone"
                        placeholder="请输入联系电话"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
                <el-form-item label="发货地：" prop="name" class="shipping-Address-box">
                  <template slot="label"><span class="red-c">*</span>发货地：</template>
                    <el-select v-model="provinceData" placeholder="请选择" style="margin-right: 10px">
                      <el-option
                              v-for="item in province"
                              :key="item.areaId"
                              :label="item.areaName"
                              :value="item.areaId"
                      ></el-option>
                    </el-select>

                  <el-select v-model="cityData" placeholder="请选择" style="margin-right: 10px">
                    <el-option
                            v-for="item in city"
                            :key="item.areaId"
                            :label="item.areaName"
                            :value="item.areaId"
                    ></el-option>
                  </el-select>
                  <el-select v-model="countyData" placeholder="请选择" style="margin-right: 10px" >
                    <el-option
                            v-for="item in county"
                            :key="item.areaId"
                            :label="item.areaName"
                            :value="item.areaId"></el-option>
                  </el-select>
                  <el-input
                          v-model="shipInfo.address"
                          placeholder="请输入详细地址"
                          style="width: 200px; margin-right: 10px"></el-input>
                  <eui-btn
                          type="primary"
                          font-size="12px"
                          @click="chooseShippingAddress">选择发货地址</eui-btn>
                  <eui-btn type="primary" font-size="12px" @click="toAddAddress"
                  >维护发货地</eui-btn
                  >
                </el-form-item>

            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="包装类型：">
                 <el-input v-model="shipInfo.packingType" placeholder="请输入包装类型"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="货物类型：">
                 <el-input v-model="shipInfo.cargoType" placeholder="请输入货物类型"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row></el-row>
        </el-form>
      </div>

      <div class="appendix flex margin-b10 margin-l56">
        <div class="flex-a-c margin-t10">
          <span class="red-c" style="margin-top: 6px" v-if="orderBaseInfo.valvePartsOrder">*</span>
          <div class="margin-r10" style="font-size: 14px">附件：</div>
          <el-upload
                  ref="uploadFile"
                  :action="fileUploadForDeliverUrl"
                  :headers="headers"
                  :show-file-list="false"
                  :auto-upload="true"
                  :on-success="handleSuccess"
                  :before-upload="handleBeforeUpload"
          >
            <eui-btn icon="eicon-upload" iconPosition="left" type="secondary">上传附件</eui-btn>
          </el-upload>
          <div class="tip-word">{{uploadTip}}</div>
        </div>
      </div>
      <!--附件样式 操作-->
      <div class="attach-mapper" v-if="deliverFiles.length > 0" style="margin: 10px 20px 0 52px;">
        <div class="attach-box flex-sb" v-for="(item,fileIndex) in deliverFiles" :key="fileIndex"
             :class="[fileIndex === 3 ? '' : 'margin-r20',fileIndex === 0 ? 'margin-b10' :'']"
        >
          <div class="attach-left">
            <div class="flex">
              <eui-icon icon="eicon-file" fontSize="16px" color="#666666"
                        style="margin-top: 1px"></eui-icon>
              <span>
                                 <eui-tooltip-over class="file-name" :tooltipStyle="{ 'width': '180px' }"
                                                   style="display: inline-block;margin-left: 8px"
                                                   :content="item.attachmentName">
                                      <span>{{item.attachmentName}}</span>
                                 </eui-tooltip-over>
                          </span>
            </div>

            <div class="flex" style="margin-left: 24px;margin-top: 4px">
              <div class="label-item" v-if="item.tags" @click.stop="handleDelLabel(fileIndex)">
                {{item.tags}}
                <eui-icon icon="eicon-close" fontSize="10px" color="#666666"
                          style="margin-bottom: 1px"></eui-icon>
              </div>
              <div class="choose-label" @click="handleChooseLabel(fileIndex)">选择附件标签</div>
            </div>
          </div>
          <div class="attach-right" @click.stop="handleDelFile(fileIndex)">
            <eui-icon icon="eicon-close" fontSize="14px" color="#666666"></eui-icon>
          </div>
        </div>
      </div>
        <div class="flex-sc" style="margin-left: 30px">
            <el-checkbox v-model="isReadAgree"></el-checkbox>
          <div class="margin-l10">我已阅读并同意 <span class="color-blue"><span @click="showAgreement('serviceAgreement')">《易物流云平台用户服务协议》</span>、<span
                  @click="showAgreement('platformRule')">《易物流云平台运营规则》</span></span></div>
        </div>
      <!--询比价发货优化 -->
      <inquiry-shipping v-if="Number(shipInfo.transportType) === 4"
                        :unitvolumeAll="unitvolumeAll"
                        :unitweightAll="unitweightAll"
                        :province="String(shipInfo.province)"
                        :city="String(shipInfo.city)"
                        ref="inquiryShipping"/>
    </div>

    <div class="back">
      <div class="button" @click="toBack">
        <i class="el-icon-arrow-left" />
        返回
      </div>
      <div class="operate">
        <el-checkbox
          v-model="isAll"
          v-if="
            orderBaseInfo.orderSource != 5 && orderBaseInfo.orderSource != 9
          "
          >已完全发货</el-checkbox
        >
        <div class="close" v-debounce="supplierShip">
          {{ Number(shipInfo.transportType) === 4 ? '询价' : '发货' }}
        </div>
      </div>
    </div>
    <eDialog
      dialogType="warning"
      :dialogTitle="dialogTitle"
      :dialogContent="dialogContent"
      @updateVisible="updateVisible"
      @resetPopupData="updateVisible"
      :showBtn="true"
      @submitPopupData="submitPopupData"
      :centerDialogVisible="visible"
      :popupWidth="'600px'"
    ></eDialog>
    <!--    选择发货地址弹框-->
    <shipping-address-dialog
      v-if="shippingAddressVisible"
      :shippingAddressVisible="shippingAddressVisible"
      :chooseAddressId="chooseAddressRow.addressId"
      :tableData="shipQueryTableData"
      @closeDialog="closeDialog"
      @submitAddress="submitAddress"
    />
    <!--关联物流单弹框-->
    <relate-logistics-order-dialog
      v-if="relateLogisticsOrderVisible"
      :relateLogisticsOrderVisible="relateLogisticsOrderVisible"
      @closeDialog="closeDialog"
      @chooseLogistics="chooseLogistics"
    />
    <amount-tip-dialog
            v-if="amountTipVisible"
            :amountTipVisible="amountTipVisible"
            :totalAmount="shipInfo.inquiryShipAO.totalAmount"
            @closeDialog="closeDialog"
            @supplierShip="supplierShip"
    />
    <!--同ip下单提示-->
    <same-ip-dialog
            v-if="sameIpTip"
            :sameIpTip.sync="sameIpTip"
    />
    <!--选择附件标签-->
    <label-dialog
            v-if="labelVisible"
            :labelVisible.sync="labelVisible"
            :chooseLabelParent="chooseLabelParent"
            @confirmLabel="confirmLabel"
    />
      <!--服务协议和平台规则的弹框-->
      <e-dialog
              :dialog-title="agreementFlag === 'serviceAgreement' ? '易物流云平台用户服务协议' : '易物流云平台运营规则'"
              :center-dialog-visible="showAgreementVisible"
              popup-width="900px"
              :onlyShowCancel="true"
              cancelButtonTip="关闭"
              @resetPopupData="showAgreementVisible = false">
          <div class="box_text" v-html="agreementContent"></div>
      </e-dialog>
  </div>
</template>

<script>
import TableList from '../../components/common/e-table-list';
import api from '../../api/order';
import userApi from '../../api/user';
import logisticsApi from '../../api/logistics';
import store from '../../store';
import fileUploadApi from '../../api/product/index.js';
import { epecToken } from '../../utils/globalData';
import eTooltip from '../../components/common/e-tooltip';
import eDialog from '../../../../components/common/e-dialog';
import shippingAddressDialog from './common/shippingAddressDialog';
import relateLogisticsOrderDialog from './common/relateLogisticsOrderDialog';
import transportCapabilityDialog from './common/transportCapabilityDialog';
import amountTipDialog from './common/amountTipDialog';
import inquiryShipping from './common/inquiryShipping';
import { labelData } from './common/orderDeliverTableLabel';
import sameIpDialog from './common/sameIpDialog';
import labelDialog from './common/labelDialog';
import {serviceAgreementData, platformRuleData} from './common/agreementData';

export default {
  name: 'orderDeliverDetail',
  components: {
    TableList,
    eTooltip,
    eDialog,
    shippingAddressDialog,
    relateLogisticsOrderDialog,
    amountTipDialog,
    transportCapabilityDialog,
    inquiryShipping,
    sameIpDialog,
    labelDialog
  },
  data() {
    return {
      agreementFlag: '',
      showAgreementVisible: false,
      agreementContent: '',
      isReadAgree: false,
      isCheckedAgree: false,//已经勾选过了
      uploadTip: '',
      sameIpTip: false,
      amountTipVisible:false,
      carList: [],
      driverList: [],
      transportCapability: false, //易物流运力
      emergencyProcurement: false, //紧急采购
      handleConfirm: false, //处理弹框点了确认之后 自动调用 取消
      dialogTitle: '完全发货提示',
      dialogContent:
        '您正在操作完全发货，请确保与采购商达成一致，未发货商品将不再继续发货，订单数量最终以实际收货为准，是否确认？',
      visible: false,
      fileUploadForDeliverUrl: fileUploadApi.fileUploadForDeliver,
      fileArr: [],
      // 私有仓库得地址
      privateUpload: {
        keyName: 'filePath',
        url: api.getSupplierLicenceUrl,
        method: 'get',
      },
      wordFlag: true,
      headers: epecToken,
      isAll: 0,
      fileList: [],
      eWuliuOption: [
        { value: '4', label: '空运' },
        { value: '3', label: '水运' },
        { value: '2', label: '陆运' },
        { value: '6', label: '铁路' },
        { value: '0', label: '其他' },
      ],
      transportMethod: [
        {
          value: '1',
          label: '快递/快运',
        },
        {
          value: '2',
          label: '陆运',
        },
        {
          value: '3',
          label: '海运',
        },
        {
          value: '4',
          label: '空运',
        },
        {
          value: '6',
          label: '铁路',
        },
        {
          value: '5',
          label: '多式联运',
        },
      ],
      shipQueryTableData: [],
      expressCompary: [],
      query: {
        orderId: null,
        purchaseCompanyId: null,
      },
      deliveryMethod: '1',
      deliveryForm: {
        deliveryMethod: '',
        company: '',
        carrierId: '',
        carrierName: '',
      },
      province: [],
      provinceData: '',
      city: [],
      cityData: '',
      county: [],
      countyData: '',
      orderBaseInfo: {},
      shipmentInfo: {},
      orderSkuInfo: {},
      deliNameOptions: [],
      deliName: '',
      shippingAddressVisible: false, //选择发货地址弹框
      deliveryInfo: {
        deliName: null,
        deliPhone: null,
        licensePlateNumber: null,
      },
      loading: false,
      tableData: [],
      tableLabel: [],
      listReceiveItem: [],
      deliverFiles: [],
      chooseAddressRow: {}, //弹框选择得 地址
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      pickerOptionsArrivalTime: {
        disabledDate: (time) => {
          const estimatedShipDate = new Date(
            this.shipInfo.estimatedShipDate
          ).getTime();
          if (estimatedShipDate) {
            return estimatedShipDate > time.getTime();
          }
        },
      },
      shipInfo: {
        shippingMethodId: '', //紧急发送的 运输方式
        shippingMethod: '', //紧急发送的 运输方式 描述
        estimatedShipDate: '', //预计发货时间
        estimatedArrivalTime: '', //预计到货时间
        carrierName: '',
        orderId: '',
        orderCode: '',
        purchaseCompanyId: '',
        orderShipmentName: '',
        address: null,
        province: '',
        provinceno: null,
        city: '',
        cityno: null,
        county: null,
        countyno: null,
        unitweight: null,
        unitvolume: null,
        transportType: 2,
        listAttachment: [],
        isAllSent: 0,
        orderDelivery: {},
        phoneAfterf: '',
        billNo: null,
        cargoType: null, //货物类型
        packingType: null, //包装类型
        channelType: '', //运输方式中文
        channelId: '',
        ywlOrderCode: '',
        useEwuliu: false, //使用易物流
        inquiryShipAO:{},
      },
      supplierShipFlag: false,
      deliveryQuantityData: [],
      relateLogisticsOrderVisible: false, //关联物流单
      logisticsOrderData: [],
      chooseLogisticsData: [], //选择的物流单

      unitweightAll:0,
      unitvolumeAll:0,

      //label参数
      labelFileIndex: 0,
      chooseLabelParent: '',
      labelVisible: false,
    };
  },
  methods: {
    showAgreement(flag) {
      this.showAgreementVisible = true;
      this.agreementFlag = flag;
      this.agreementContent = flag === 'serviceAgreement' ? serviceAgreementData : platformRuleData
    },
    //修改 总重量、总体积
    changeNum(){
      this.unitweightAll = this.tableData.reduce((pre, cur) => {return pre + Number(cur.goodsWeight);}, 0);//总重量
      this.unitvolumeAll = this.tableData.reduce((pre, cur) => {return pre + Number(cur.goodsVolume);}, 0);//总体积
      //清空单价或者整单价格
      this.$refs.inquiryShipping.inquiryShipAO.amount = '';
      this.$refs.inquiryShipping.inquiryShipAO.totalAmount = '';
      this.$refs.inquiryShipping.amount = '';
      this.$refs.inquiryShipping.totalAmount = '';
    },
    estimatedShipDateChange() {
      this.shipInfo.estimatedArrivalTime = '';
    },
    driverChange(val) {
      const driverData = this.driverList.filter((item) => item.phone === val);
      if (driverData.length > 0) {
        this.deliveryInfo.deliName = driverData[0].driver;
      }
    },
    chooseTransport(data) {
      this.deliveryInfo.deliName = data.deliName;
      this.deliveryInfo.deliPhone = data.deliPhone;
      this.deliveryInfo.licensePlateNumber = data.licensePlateNumber;
    },
    async getDrivers() {
      this.carList = [];
      this.driverList = [];
      const res = await logisticsApi.getDrivers();
      if (res.success) {
        const carList = res.data.carList || [];
        carList.forEach((item) => {
          this.carList.push({ value: item, label: item });
        });
        this.driverList = res.data.driverList || [];
      }
    },
    //易物流运力 切换
    transportCapabilityChange(val) {
      this.deliveryInfo.deliName = '';
      this.deliveryInfo.deliPhone = '';
      this.deliveryInfo.licensePlateNumber = '';
      if (val) {
        this.getDrivers();
        this.shipInfo.useEwuliu = true;
        this.deliveryMethod = '2'; //设置 shipInfo.channelId = '2' 与 shipInfo.channelType = '陆运'
        this.shipInfo.shippingMethodId = '2'; //紧急发送的 运输方式
        this.shipInfo.shippingMethod = '陆运'; //紧急发送的 运输方式
      } else {
        //取消选中  清空数据
        this.clearEwuliuData();
      }
    },
    toEwuliiu() {
      if (process.env.NODE_ENV === 'production') {
        window.open(
          'https://ewuliu-general.epec.com/#/carDriver/carDriver',
          '_blank'
        );
      } else {
        window.open(
          'https://dev-a-ewuliu-supplier.epec.com/#/carDriver/carDriver',
          '_blank'
        );
      }
    },
    //关联物流单
    relateLogisticsOrder() {
      this.relateLogisticsOrderVisible = true;
    },
    submitPopupData() {
      this.visible = false;
      this.handleConfirm = true;
    },
    updateVisible() {
      if (!this.handleConfirm) {
        this.visible = false;
        this.isAll = false;
      }
      setTimeout(() => {
        this.handleConfirm = false;
      }, 1000);
    },
    handleSelect(item) {
      this.deliveryInfo.deliPhone = item.deliPhone;
      this.deliveryInfo.licensePlateNumber = item.licensePlateNumber;
    },
    toAddAddress() {
      this.$router.push({ path: '/address' });
    },
    //选择发货地址
    chooseShippingAddress() {
      this.shippingAddressVisible = true;
    },
    //弹框选择得地址
    submitAddress(row) {
      if (Object.keys(row).length === 0) {
        this.shippingAddressVisible = false;
        return false;
      }
      this.chooseAddressRow = row;
      this.shipInfo.address = row.address;
      this.deliveryInfo.deliName = row.realName;
      this.deliveryInfo.deliPhone = row.mobile;
      this.shippingAddressVisible = false;
      this.provinceData = Number(row.provinceAreaId);
      //获取市
      this.queryByParentId(this.provinceData, 'province');
      //获取 区
      this.queryByParentId(this.cityData, 'city');
      setTimeout(() => {
        this.countyData = Number(row.countryAreaId);
        this.cityData = Number(row.cityAreaId);
      }, 300);
    },
    //选择物流
    chooseLogistics(row) {
      this.chooseLogisticsData = row;
      this.relateLogisticsOrderVisible = false;

      this.deliveryForm.carrierId = row.carrierName;
      this.shipInfo.carrierName = row.carrierName;
      this.deliveryInfo.deliName = row.consignor;
      this.deliveryInfo.deliPhone = row.consignorPhone;
      this.shipInfo.unitweight = row.weight;
      this.shipInfo.unitvolume = row.volume;
      this.shipInfo.address = row.consignorAddrInfo;
      this.shipInfo.ywlOrderCode = row.ywlOrderCode;

      const consignorAddr = row.consignorAddr.split(',');
      this.provinceData = consignorAddr[0];
      this.cityData = consignorAddr[1];
      this.countyData = consignorAddr[2];
      this.shipInfo.province = consignorAddr[0];
      this.shipInfo.city = consignorAddr[1];
      this.shipInfo.county = consignorAddr[2];
    },
    closeDialog() {
      this.shippingAddressVisible = false;
      this.relateLogisticsOrderVisible = false;
      this.amountTipVisible = false;
    },
    querySearch(queryString, cb) {
      let deliNameOptions = this.deliNameOptions;
      let results = queryString
        ? deliNameOptions.filter((item) => item.deliName == queryString)
        : deliNameOptions;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    //送货人姓名
    getDeliPersonInfo() {
      api.queryOrderDelivery({ deliName: null }).then((res) => {
        if (res.code == 200) {
          this.deliNameOptions = res.data;
          this.deliNameOptions.forEach((item) => {
            item.value = item.deliName;
          });
          this.getLatestTimeDelivery();
        }
      });
    },
    wordShow() {
      this.wordFlag = !this.wordFlag;
    },
    setValue(val) {
      console.log(val);
      this.$forceUpdate();
    },
    //获取地区信息
    queryByParentId(data, flag) {
      //陆运选择 紧急 发货 传过来的数据 不支持查询
      if (typeof data === 'string') {
        this.city = [];
        this.county = [];
        return false;
      }
      api.queryByParentId({ parentAreaId: data ? data : 0 }).then((res) => {
        if (!data) {
          //获取省
          this.province = res.data;
        } else if (flag == 'province') {
          //获取市
          this.city = res.data;
        } else {
          this.county = res.data;
        }
      });
    },
    clearNoNum(obj) {
      //先把非数字的都替换掉，除了数字和.
      obj.value = obj.value.replace(/[^\d.]/g, '');
      //必须保证第一个为数字而不是.
      obj.value = obj.value.replace(/^\./g, '');
      //保证只有出现一个.而没有多个.
      obj.value = obj.value.replace(/\.{2,}/g, '.');
      //保证.只出现一次，而不能出现两次以上
      obj.value = obj.value
        .replace('.', '$#$')
        .replace(/\./g, '')
        .replace('$#$', '.');
    },
    //校验每一条商品发货数量
    calDeliveryQuantity(data, index) {
      //判断是不是溢装
      if (this.orderBaseInfo.hasOverShipment != '1') {
        let sum =
          Number(data.quantity) * Number(data.overShipmentRate) +
          Number(data.quantity) -
          Number(data.sentQuantity);

        if (Number(data.deliveryQuantity) > Number(sum)) {
          this.$message.warning('本次发货数量不能超过未发数量与溢装率之和');
          this.supplierShipFlag = true;
          return;
        }
      }

      this.tableData[index].deliveryQuantity = Number(
        data.deliveryQuantity
      ).toFixed(3);
      this.supplierShipFlag = false;
      //   let index = this.deliveryQuantityData.findIndex(item => item.orderSkuId == data.orderSkuId)
      //   if(index != -1){
      //     this.deliveryQuantityData.splice(index,1)
      //   }
      // this.deliveryQuantityData.push({deliveryQuantity:data.deliveryQuantity,orderSkuId:data.orderSkuId})
    },
    toBack() {
      // this.$router.push({ path: "/orderManage" })
      this.$router.back();
    },
    getOrderDetail() {
      api
        .queryShipOrderDetail(this.query)
        .then((res) => {
          this.shipmentInfo = res.data.shipmentVO;
          this.orderBaseInfo = res.data;
          this.shipInfo.orderShipmentName =
            this.orderBaseInfo.autoGeneratedDeliveryName;
          this.tableData = res.data.skuList;
          this.tableData.forEach((item) => {
            this.$set(item, 'deliveryQuantity', item.unSentQuantity);
            this.$set(item, 'goodsVolume', '');
            this.$set(item, 'goodsWeight', '');
          });

          if (this.orderBaseInfo.valvePartsOrder) {
            this.uploadTip = '需上传质检报告、检验证明、质量文件、采购说明等附件，最多上传5个附件，格式不限，每个附件大小不超过200M。';
          } else {
            this.uploadTip = '非必填，最多上传5个附件，格式不限，每个附件大小不超过200M';
          }

          this.chooseLabel();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    chooseLabel() {
      //是否溢装
      if (Boolean(this.orderBaseInfo.hasOverShipment)) {
        //溢装
        if (Number(this.shipInfo.transportType) === 4) {
          //询比价
          this.tableLabel = labelData.tableLabelInquiry;
        } else {
          this.tableLabel = labelData.tableLabel;
        }
      } else {
        //不溢装
        if (Number(this.shipInfo.transportType) === 4) {
          //询比价
          this.tableLabel = labelData.tableLabelNoOverInquiry;
        } else {
          this.tableLabel = labelData.tableLabelNoOver;
        }
      }
    },
    //采购商发货
    supplierShip() {

      if (Number(this.shipInfo.transportType) === 0) {
        if (!this.deliveryInfo.deliName) {
          this.$message.warning('送货人姓名不能为空。');
          return false;
        }
        if (!this.deliveryInfo.deliPhone) {
          this.$message.warning('送货人电话不能为空。');
          return false;
        }
        if (!this.deliveryInfo.licensePlateNumber) {
          this.$message.warning('送货人车牌号不能为空。');
          return false;
        }
        if (
          this.deliveryInfo.deliName.length < 1 ||
          this.deliveryInfo.deliName.length > 50
        ) {
          this.$message.warning('送货人姓名长度不符合要求，仅可输入1-50个字符');
          return false;
        }
        if (!/^1[3|4|5|7|8]\d{9}$/.test(this.deliveryInfo.deliPhone)) {
          this.$message.warning('请输入正确的手机号。');
          return false;
        }
        if (
          this.deliveryInfo.licensePlateNumber.length < 4 ||
          this.deliveryInfo.licensePlateNumber.length > 50
        ) {
          this.$message.warning(
            '送货人车牌号长度不符合要求，仅可输入4-50个字符'
          );
          return false;
        }
      }

      //判断是不是溢装
      if (this.supplierShipFlag && this.orderBaseInfo.hasOverShipment != '1') {
        this.$message('商品得发货数量不能超过采购数量与溢装率之和，请核实');
        return;
      }

      if (this.deliveryForm.carrierId) {
        if (this.deliveryForm.carrierId == 'SF') {
          if (!this.shipInfo.phoneAfterf) {
            this.$message.warning('手机号后四位不能为空');
            return;
          } else {
            if (this.shipInfo.phoneAfterf.length < 4) {
              this.$message.warning('联系方式位数至少为四位');
              return;
            } else if (this.shipInfo.phoneAfterf.length > 4) {
              this.shipInfo.phoneAfterf = this.shipInfo.phoneAfterf.substring(
                this.shipInfo.phoneAfterf.length - 4
              );
            }
          }
        }

        //增加紧急配送
        const expressComparyArr = this.expressCompary.filter(
          (item) => item.value == this.deliveryForm.carrierId
        );
        if (expressComparyArr.length > 0) {
          this.deliveryForm.carrierName = expressComparyArr[0].label;
          this.shipInfo.carrierName = this.deliveryForm.carrierName;
          this.shipInfo.carrierId = this.deliveryForm.carrierId;
        }
      } else {
        if (Number(this.shipInfo.transportType) === 2) {
          if (this.expressCompary.length > 0) {
            this.$message.warning(
              this.deliveryMethod == 1
                ? '快递公司不能为空'
                : '运输商选择不能为空'
            );
          } else {
            this.$message.warning(
              this.deliveryMethod == 1
                ? '快递公司为空不能选择此运输方式'
                : '运输商选择为空不能选择此运输方式'
            );
          }
          return;
        }
      }

      //第三方物流
      if (Number(this.shipInfo.transportType) === 2) {
        //快递快运
        if (this.deliveryMethod && this.deliveryMethod == '1') {
          if (!this.shipInfo.billNo) {
            this.$message.warning('快递单号不能为空。');
            return false;
          }
        }
        // 非  快递/快运 必填校验
        if (this.deliveryMethod && this.deliveryMethod != '1') {
          if (!this.deliveryInfo.deliName) {
            this.$message.warning('发货人不能为空。');
            return false;
          }
          if (!this.deliveryInfo.deliPhone) {
            this.$message.warning('联系电话不能为空。');
            return false;
          }
          if (!this.shipInfo.address) {
            this.$message.warning('请输入详细地址。');
            return false;
          }
          if (!this.provinceData) {
            this.$message.warning('请选择省及直辖市。');
            return false;
          }
          if (!this.cityData) {
            this.$message.warning('请选择市。');
            return false;
          }
          if (!this.countyData) {
            this.$message.warning('请选择县/区。');
            return false;
          }
          if (!this.shipInfo.unitweight) {
            this.$message.warning('请输入总重量。');
            return false;
          }
          if (!this.shipInfo.unitvolume) {
            this.$message.warning('请输入总体积。');
            return false;
          }
          let reg = new RegExp('^[0-9]*$');
          const unitvolume = Number(this.shipInfo.unitvolume);
          const unitweight = Number(this.shipInfo.unitweight);
          if (!reg.test(unitvolume) || !reg.test(unitweight)) {
            this.$message.warning(
              '总重量、总体积只能输入数字，请检查后重新填写。'
            );
            return false;
          }
        }
      }

      //询比价
      if (Number(this.shipInfo.transportType) === 4) {
        let warmTip = '';
        //总重量、总体积必须有值
        try{
          this.tableData.forEach(item=>{
            if(!item.goodsWeight){
              warmTip = '货物重量不能为空。';
              throw Error();
            }
            if(!item.goodsVolume){
              warmTip = '货物体积不能为空。';
              throw Error();
            }
          })
        }catch (e) {
          this.$message.warning(warmTip);
          return false;
        }

        if (!this.deliveryInfo.deliName) {
          this.$message.warning('发货人姓名不能为空。');
          return false;
        }
        if (!this.deliveryInfo.deliPhone) {
          this.$message.warning('联系电话不能为空。');
          return false;
        }
        if (!this.shipInfo.address) {
          this.$message.warning('请输入详细地址。');
          return false;
        }
        if (!this.provinceData) {
          this.$message.warning('请选择省及直辖市。');
          return false;
        }
        if (!this.cityData) {
          this.$message.warning('请选择市。');
          return false;
        }
        if (!this.countyData) {
          this.$message.warning('请选择县/区。');
          return false;
        }
        if (!/^1[3|4|5|7|8]\d{9}$/.test(this.deliveryInfo.deliPhone)) {
          this.$message.warning('请输入正确的手机号。');
          return false;
        }

        //校验必填字段
        if(!this.$refs.inquiryShipping.verifyMandatoryData()){
          return false;
        }
        //封装字段
        this.shipInfo.inquiryShipAO = this.$refs.inquiryShipping.inquiryShipAO;
        this.shipInfo.unitvolume = this.unitvolumeAll;
        this.shipInfo.unitweight = this.unitweightAll;

        if(this.shipInfo.inquiryShipAO.orderType === 1 && Number(this.shipInfo.inquiryShipAO.totalAmount) > 100000 && !this.amountTipVisible){
          this.amountTipVisible = true;
          return false;
        }

        this.amountTipVisible = false;
       }

      //判断附件
      if (this.orderBaseInfo.valvePartsOrder && this.deliverFiles.length === 0) {
        this.$message('请上传附件');
        return false;
      }

      if (this.countyData) {
        // this.shipInfo.county = this.county.filter(item => item.areaId == this.countyData)[0].areaName;
        const countyArr = this.county.filter(
          (item) => item.areaId == this.countyData
        );
        if (countyArr.length > 0) {
          this.shipInfo.county = countyArr[0].areaName;
          this.shipInfo.countyno = this.countyData;
        }
      }

      this.shipInfo.isAllSent = this.isAll ? 1 : 0;
      this.shipInfo.orderDelivery = this.deliveryInfo;
      this.$set(this.shipInfo, 'receiveName', this.shipmentInfo.receiveName);
      if (this.deliveryMethod) {
        this.shipInfo.channelId = this.deliveryMethod;

        const channelTypeArr = this.transportMethod.filter(
          (item) => item.value == this.deliveryMethod
        );
        if (channelTypeArr.length > 0) {
          this.shipInfo.channelType = channelTypeArr[0].label;
        }
        // this.shipInfo.channelType = this.transportMethod.filter(item => item.value == this.deliveryMethod)[0].label;
      }

      let listReceiveItem = [];
      let deliveryNumFlag = false;
      this.tableData.forEach((item) => {
        if (item.deliveryQuantity && Number(item.deliveryQuantity) > 0) {
          listReceiveItem.push({ ...item });
        }
        if (item.deliveryQuantity && Number(item.deliveryQuantity) < 0) {
          deliveryNumFlag = true;
        }
      });

      if (deliveryNumFlag) {
        this.$message.warning('发货数量不能为负数。');
        return;
      }

      if (!this.isReadAgree) {
        this.$message.warning('请您阅读并同意《易物流云平台用户服务协议》《易物流云平台运营规则》后可进行提交。');
        return;
      } else {
        //已经勾选过 就不用勾选了，仅限第一次勾选
        if (!this.isCheckedAgree) {
          this.changeAgree();
        }
      }

       api
        .supplierShipOrder({
          ...this.shipInfo,
          listReceiveItem: listReceiveItem,
          listAttachment: this.deliverFiles,
        })
        .then((res) => {
          if (res.code == '200') {
            const mes = Number(this.shipInfo.transportType) === 4 ? '询价成功' : '订单发货成功';
            this.$message.success(mes);
            setTimeout(() => {
              let times = new Date();
              times = times.getTime();
              this.$router.push({ path: '/orderManage', query: { t: times } });
              // this.$router.back();
            }, 1000);
          } else if (res.code === 'SAME_IP_ADDRESS') {
            this.sameIpTip = true;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleChange(res, file) {
      console.log(file, 'fil是是是e');

      // this.shipInfo.listAttachment.push({attachmentName: file.response.fileName, attachmentUrl:file.response.fileUrl})
    },
    handleBeforeUpload(file) {
      let size = file.size / 1024 / 1024;
      if (size > 200) {
        this.$message.warning('图片不能超过200M');
        return;
      }
    },
    //附件上传成功处理
    handleSuccess(res, file) {
      if (this.deliverFiles.length === 5) {
        this.$message.warning({message: '只能上传五个附件。',});
        return false;
      }
      if (res.success) {
        let params = {
          tags: '',
          attachmentName: file.name,
          attachmentUrl: file.response.data.fileUrl,
        }
        this.deliverFiles.push(params);
      }
    },
    //删除文件
    handleRemove(file) {
      this.$confirm(`确定移除 ${file.name}？`).then(() => {
        this.shipInfo.listAttachment.splice(
          this.shipInfo.listAttachment.findIndex(
            (item) => item.uid == file.uid
          ),
          1
        );
        this.$message.success('删除成功。');
      });
    },
    //删除选中标签
    handleDelLabel(fileIndex) {
      this.deliverFiles[fileIndex].tags = '';
    },
    //删除文件
    handleDelFile(fileIndex) {
      this.deliverFiles.splice(fileIndex, 1);
    },
    handleChooseLabel(fileIndex) {
      this.chooseLabelParent = this.deliverFiles[fileIndex].tags || '';

      this.labelFileIndex = fileIndex;//供应商附件得 index
      this.labelVisible = true;
    },
    //确认选中label
    confirmLabel(label) {
      this.deliverFiles[this.labelFileIndex].tags = label;
    },
    supplyChoose() {
      let resData = [];
      if (!this.shipInfo.billNo) {
        this.$message.warning('请输入快递单号');
        return;
      }
      api
        .selectExpressCompanyByBillNo({ billNo: this.shipInfo.billNo })
        .then((res) => {
          resData = res.data;
          this.expressCompary = resData
            ? resData.map((item) => {
                return { value: item.shipperCode, label: item.shipperName };
              })
            : [];
        });
    },
    //获取最新的一次发货人信息
    getLatestTimeDelivery() {
      api.getLatestTimeDelivery().then((res) => {
        if (res.code == 200 && res.data) {
          this.deliveryInfo.deliName = res.data.deliName;
          this.deliveryInfo.deliPhone = res.data.deliPhone;
          this.deliveryInfo.licensePlateNumber = res.data.licensePlateNumber;
        } else if (this.deliNameOptions.length > 0) {
          this.deliveryInfo.deliName = this.deliNameOptions[0].deliName;
          this.deliveryInfo.deliPhone = this.deliNameOptions[0].deliPhone;
          this.deliveryInfo.licensePlateNumber =
            this.deliNameOptions[0].licensePlateNumber;
        }
      });
    },
    async shipQueryList() {
      let res = await api.shipQueryList();
      if (res.success) {
        this.shipQueryTableData = res.data;
      }
    },
    //运输商的查询
    async queryCompanyTransport() {
      await api
        .queryCompanyTransport({
          companyId: store.state.USERINFO.companyId,
          transpostType: this.deliveryForm.deliveryMethod,
        })
        .then((res) => {
          const resData = res.data;
          this.expressCompary = resData
            ? resData.map((item) => {
                return { value: item.companyId, label: item.companyName };
              })
            : [];
        });
    },
    noSelect() {
      //陆运的 紧急采购 不查询
      if (this.emergencyProcurement) {
        //是
        this.shipInfo.cityno = '';
        this.shipInfo.countyno = '';
        this.shipInfo.provinceno = '';
        return true;
      } else {
        //不是
        return false;
      }
    },
    //切换配送方式 如果是 紧急采购 则清空
    clearEmergencyProcurement() {
      this.deliveryForm.carrierId = '';
      this.deliveryInfo.deliName = '';
      this.deliveryInfo.deliPhone = '';
      this.shipInfo.unitweight = '';
      this.shipInfo.unitvolume = '';
      this.shipInfo.address = '';

      this.provinceData = '';
      this.cityData = '';
      this.countyData = '';
      this.shipInfo.province = '';
      this.shipInfo.city = '';
      this.shipInfo.county = '';
      this.shipInfo.ywlOrderCode = '';

      this.chooseAddressRow = {};

      this.shipInfo.packingType = '';
      this.shipInfo.cargoType = '';
    },

    //使用易物流运力清空数据
    clearEwuliuData() {
      //取消选中  清空数据
      this.shipInfo.estimatedShipDate = '';
      this.shipInfo.estimatedArrivalTime = '';
      this.shipInfo.useEwuliu = false;
      this.deliveryMethod = '1'; //设置 shipInfo.channelId = '1' 与 shipInfo.channelType = '快递/快运'
      this.shipInfo.shippingMethodId = ''; //紧急发送的 运输方式
      this.shipInfo.shippingMethod = ''; //紧急发送的 运输方式
      this.shipInfo.billNo = '';
      this.deliveryInfo.deliName = '';
      this.deliveryInfo.deliPhone = '';
      this.deliveryInfo.licensePlateNumber = '';
      this.deliveryForm.carrierId = '';
      this.expressCompary = [];

    },

    //查询是否要勾选《服务协议》和《平台规则》
    async memberActionQuery() {
      let res = await userApi.memberActionQuery({action: 'serviceAgreement'});
      if (res.code === '200' && res.data) {
        const {action, value} = res.data;
        if (action === 'serviceAgreement' && value === 'popUp') {
          this.isReadAgree = true;
          this.isCheckedAgree = true;//已经勾选过
        }
      }
    },
    //已经勾选过 就不用勾选了，仅限第一次勾选
    async changeAgree() {
        let res = await userApi.memberActionSave({action: 'serviceAgreement', value: 'hidden'});
        if (res.code === '200') {
        }
    },

  },
  mounted() {
    this.query.orderId = this.$route.query.orderId;
    this.shipInfo.orderId = this.query.orderId;
    this.query.purchaseCompanyId = this.$route.query.purchaseCompanyId;
    this.shipInfo.purchaseCompanyId = this.query.purchaseCompanyId;
    this.shipInfo.orderCode = this.$route.query.orderNo;
    this.getOrderDetail();
    this.queryByParentId();
    this.getDeliPersonInfo();
    this.shipQueryList(); //选择发货地址 里的 列表
    this.memberActionQuery();//判断公司是否第一次阅读勾选协议
  },
  watch: {
    isAll(val) {
      if (val) {
        this.visible = true;
      }
    },

    provinceData(val) {
      //陆运的 紧急采购 不查询
      if (this.noSelect()) {
        return false;
      }
      this.shipInfo.provinceno = val;
      let resData = this.province.filter((item) => item.areaId == val);
      if (resData.length > 0) {
        this.shipInfo.province = resData[0].areaName;
        this.cityData = '';
        this.countyData = '';
      }
      // this.shipInfo.province = this.province.filter(item => item.areaId == val)[0].areaName;
      this.queryByParentId(val, 'province');
    },
    cityData(val) {
      //陆运的 紧急采购 不查询
      if (this.noSelect()) {
        return false;
      }
      this.shipInfo.cityno = val;
      let resData = this.city.filter((item) => item.areaId == val);
      // console.log(this.city,val,resData,'resData')
      if (resData.length > 0) {
        this.shipInfo.city = resData[0].areaName;
      }
      // this.shipInfo.city = this.city.filter(item => item.areaId == val)[0].areaName;
      this.queryByParentId(val, 'city');
    },
    deliveryMethod(val) {
      this.deliveryForm.deliveryMethod = val;
      let resData = [];
      this.deliveryForm.carrierName = '';
      this.deliveryForm.carrierId = '';
      if (val == 1) {
        this.expressCompary = [];
        // api.selectExpressCompanyByBillNo({billNo:this.shipInfo.billNo?this.shipInfo.billNo:''}).then((res)=>{
        //   resData = res.data;
        //   this.expressCompary = resData ? resData.map(item =>{return {value:item.shipperCode,label:item.shipperName};}) :[];
        // })
      } else {
        this.queryCompanyTransport(); //运输商的查询
        //判断是否是陆运
        if (val === '2') {
          const len = Object.keys(this.chooseLogisticsData).length;
          if (len > 0) {
            this.emergencyProcurement = true;
            this.chooseLogistics(this.chooseLogisticsData);
          } else {
            this.emergencyProcurement = false;
          }
        } else {
          this.emergencyProcurement = false;
        }
      }
    },
    emergencyProcurement(val) {
      if (!val) {
        this.queryCompanyTransport();
      }
      this.clearEmergencyProcurement(); //清空数据
    },
    //切换配送方式  第三方物流 2；自行配送  0；询比价  4
    'shipInfo.transportType'(val) {
      this.chooseLabel(); //更换Label
      this.deliveryMethod = '1';
      if (Number(val) !== 2 && this.emergencyProcurement) {
        this.emergencyProcurement = false;
      }

      this.clearEwuliuData();
      this.transportCapability = false;
      this.shipInfo.unitvolume = '';
      this.shipInfo.unitweight = '';
      this.shipInfo.inquiryShipAO = {};
    },
    deep: true,
  },
};
</script>

<style scoped lang="scss">
.order-detail {
  font-size: 14px;
  .margin-b10{
    margin-bottom: 20px;
  }
  .max-width {
    width: 100%;
  }
  .red-c{
    color: #EF4C56;
  }
  .delivery-quantity {
    ::v-deep .el-input__inner {
      text-align: center;
      border-color: transparent;
      &:focus {
        border-color: #2587ff;
      }
    }
  }
  ul {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    width: 100%;
    .word-show {
      margin: 10px 10px 0 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      height: 20px;
      white-space: normal;
      flex-basis: 49%;
      position: relative;
      padding-left: 30px;
      .write {
        position: absolute;
        left: 4px;
        top: 2px;
        background: url('../../../../assets/img/write-gray.png') no-repeat
          center center;
        background-size: 12px;
      }
      &:hover .write {
        background: url('../../../../assets/img/write.png') no-repeat center
          center;
        background-size: 12px;
      }
      .close {
        position: absolute;
        right: 4px;
        top: 4px;
        background: url('../../../../assets/img/success.png') no-repeat center
          center;
        background-size: 12px;
      }
      &:hover {
        background-color: #f4f7ff;
      }
      &:hover .close {
        background: url('../../../../assets/img/close.png') no-repeat center
          center;
        background-size: 10px;
      }
      img {
        width: 12px;
        height: 16px;
        margin: -2px 12px;
      }
      span {
        color: #0064c8;
        font-size: 14px;
      }
      .close {
        width: 12px;
        height: 12px;
        cursor: pointer;
      }
      .write {
        width: 12px;
        height: 16px;
        cursor: pointer;
      }
    }
  }
  .distribution {
    margin-top: 20px;
    ::v-deep .el-input {
      width: 300px;
    }
      ::v-deep .el-form-item--small.el-form-item{
          margin-bottom: 10px;
      }
  }
    .shipping-Address-box{
        ::v-deep .el-input {
            width: 100px;
        }
    }
  .form-line {
    display: flex;
    align-items: center;
  }
  .shipping-address {
    ::v-deep .el-input {
      width: 180px;
    }
  }
  .upload {
    width: 108px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    border: 1px dashed #999;
    .margin-left-4 {
      margin-left: 10px;
    }
    &:hover {
      border: 1px dotted #2587ff;
      color: #2587ff;
    }
  }

  .tip {
    padding: 0 10px 10px;
    width: 100%;
    text-align: start;
    background: #f4f7ff;
    color: #666;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    img {
      margin: 9px 10px 0;
      width: 16px;
      height: 16px;
    }
    p {
      font-size: 12px;
      margin-top: 10px;
      color: #606266;
    }
  }

    .color-blue {
        color: #2587ff;
        cursor: pointer;
    }

  .attach-mapper {

    display: flex;
    flex-wrap: wrap;

    .attach-box {
      width: 250px;
      height: 60px;
      padding: 6px 10px;
      background: linear-gradient(90deg, #F5F5F5 0%, rgba(245, 245, 245, 0.20) 100%);

      .cursor-show {
        cursor: pointer;
      }

      .attach-left {
        width: 216px;

        .margin-t4 {
          margin-top: 4px;
        }

        .label-item {
          width: 80px;
          height: 20px;
          line-height: 19px;
          border: 1px solid #D9D9D9;
          margin-right: 6px;
          color: #666;
          text-align: center;
          font-size: 12px;
          cursor: pointer;
          background-color: #fff;

          &:hover {
            background-color: #e9f3ff;
            border-color: #2587FF;
            color: #2587FF;
          }
        }

        .choose-label {
          width: 100px;
          height: 20px;
          line-height: 18px;
          border: 1px solid #2587FF;
          color: #2587FF;
          font-size: 12px;
          text-align: center;
          cursor: pointer;

          &:hover {
            background-color: #e9f3ff;
          }
        }
      }

      .attach-right {
        margin-top: 10px;
        cursor: pointer;
      }

      .file-name {
        color: #0064C8;
      }
    }
  }
  .appendix {
    font-size: 14px;
    color: #333;
    margin-left: 30px;

    .tip-word {
      color: #999;
      display: inline-block;
      margin-left: 10px;
      font-size: 12px;
    }
  }
  .margin-l56{
    margin-left: 56px;
  }
  .orderno {
    margin-top: 10px;
  }
  .info-box{
    margin-top: 10px;
    ::v-deep .el-form-item--small.el-form-item {
      margin-bottom: 0px;
    }
  }
  .deliver-goods {
    display: flex;
    .margin-left {
      margin-left: 14px;
    }
    .left {
      width: 50%;
      border-right: 1px solid #d9d9d9;
      .margin-l16 {
        margin-left: 8px;
      }
    }

    .right {
      padding: 0 30px 0 20px;
    }
  }

  .back {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .return {
      width: 80px;
      line-height: 30px;
      text-align: center;
      border: 1px solid #d9d9d9;
      margin-bottom: 10px;
      background: #fff;
      &:hover {
        border: 1px solid #2587ff;
        color: #2587ff;
      }
    }
    .button {
      width: 80px;
      height: 30px;
      line-height: 30px;
      border: 1px solid #d9d9d9;
      text-align: center;
      cursor: pointer;
      background-color: #fff;
      &:hover {
        border: 1px solid #2587ff;
        color: #2587ff;
      }
    }
    .operate {
      display: flex;
      justify-content: center;
      align-items: center;
      .close {
        width: 96px;
        line-height: 30px;
        font-size: 14px;
        background: #2587ff;
        font-weight: 400;
        color: #fff;
        text-align: center;
        cursor: pointer;
        margin-left: 20px;
        &:hover {
          background-color: #126edf;
        }
      }
    }
  }
  .title {
    font-size: 14px;
    color: #000;
    font-style: normal;
    font-weight: bold;

    .radio {
      margin: 4px 0 0 40px;
    }
  }
  .margin-l16 {
    margin-left: 16px;
  }
  .little-title {
    color: #999;
    .word {
      width: 14px;
    }
    ::v-deep .el-input {
      width: 164px;
      height: 30px;
      line-height: 30px;
    }
    ::v-deep .el-input__inner {
      &:focus {
        border: 1px solid #2587ff;
      }
    }
    ::v-deep .el-input__suffix{
      right: 14px;
    }
  }

  .line {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .black {
    color: black;
    margin-left: 10px;
  }
}
</style>
